module.exports = __webpack_public_path__ + "img/ul.0c5973e8.svg";